/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './TrackLocation.css';
import WhereField from './partials/WhereField';
import RegisterForm from './partials/RegisterForm';
import {
  login,
  register,
  fetchUser,
  getLocation,
  getRankEscape,
  addEscape,
} from '../actions';


class TrackLocation extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['location', getLocation, p => p.id],
  ];

  state = {
    flow: 'rooms',
    minutes: '',
  };

  seq = 1;

  handleRegisterSuccess(resp) {
    console.log('handleRegisterSuccess', resp);

    let room = this.state.room;
    let escape = { didEscape: this.state.outcome };
    if (this.state.outcome && this.state.minutes) {
      escape.minutes = this.state.minutes;
    }
    let params = {
      escape,
      room: { roomId: room.id },
    };
    let username = resp.user.username
    this.props.addEscape(params)
      .then(resp => {
        console.log('added escape', resp);
        navTo('/p/' + username);
      });
  }

  selectRoom(room) {
    this.setState({
      flow: 'escape',
      room: room,
    });
  }

  setMinutes(minutes) {
    this.setState({ minutes });
    let roomId = this.state.room.id;
    let params = { roomId, minutes };

    this.seq++;
    let seq = this.seq;
    this.props.getRankEscape(null, { silent: true, background: true }, params)
      .then(resp => {
        console.log('resp', resp, seq, this.seq);
        if (seq != this.seq) return;
        this.setState({ rank: resp.obj.rank });
      });
  }

  setOutcome(outcome) {
    this.setState({
      hasOutcome: true,
      outcome,
    });
  }

  saveEscape() {
    this.setState({
      flow: 'save',
    });
  }

  renderSuccess() {
    return (
      <div className="success">
        <div className="check-wrapper">
          <FontAwesome name="check-circle" />
          <div className="success-blurb">Saved your escape!</div>
        </div>
        <hr/>
        <div className="next-question">What do you want to do next?</div>
        <div className="next">
          <div className="next-choice">Review This Room</div>
          <div className="next-choice">Track More Escapes</div>
          <div className="next-choice">Find More Rooms</div>
        </div>
      </div>
    );
  }

  renderRooms() {
    let location = this.props.location;
    if (!location) return;

    console.log('render location:', location);
    let nodes = location.rooms.map(room => {
      return (
        <div className="room" onClick={() => this.selectRoom(room)}>
          {room.name}
        </div>
      );
    });

    return (
      <div className="rooms-wrapper">
        <div className="question">
          Which room did you attempt?
        </div>
        <div className="rooms">
          {nodes}
        </div>
      </div>
    );
  }

  renderEscapeForm() {
    let room = this.state.room;

    let outcomeNode;
    if (this.state.hasOutcome) {
      let continueButton;
      if (this.state.flow == 'escape') {
        continueButton = (
          <div className="continue-button" onClick={() => this.saveEscape()}>
            Continue
          </div>
        );
      }

      if (this.state.outcome) {
        let rankNode;
        if (this.state.rank) {
          rankNode = (
            <div className="rank">
              This is the <b>#{this.state.rank}</b> fastest escape from <b>{this.state.room.name}</b>
            </div>
          );
        }

        outcomeNode = (
          <div className="outcome">
            <div className="outcome-message">
              <b>Great job!</b> Enter your time to escape below:
            </div>
            <div className="time">
              <input
                value={this.state.minutes}
                onChange={(e) => this.setMinutes(e.target.value)}
              />
              <div className="time-message">minutes</div>
              <div className="time-message-optional">(optional)</div>
            </div>

            {/*rankNode*/}

            {continueButton}
          </div>
        );
      } else {
        outcomeNode = (
          <div className="outcome">
            <div className="outcome-message">
              Better luck next time. We hope you had fun anyways!
            </div>
            {continueButton}
          </div>
        );
      }
    }

    let yesActive = false;
    let noActive = false;
    let yesInactive = false;
    let noInactive = false;
    if (this.state.hasOutcome) {
      yesActive = this.state.outcome;
      noActive = !yesActive;
      yesInactive = !yesActive;
      noInactive = !noActive;
    }

    return (
      <div className="escape-form">
        <div className="room">
          {room.name}
        </div>

        <div className="did-escape-wrapper">
          <div className="question">Did you <b>escape</b>?</div>

          <div className="choices">
            <div className={cx('choice', 'yes', { active: yesActive, inactive: yesInactive })} onClick={() => this.setOutcome(true)}>Yes!</div>
            <div className={cx('choice', 'no', { active: noActive, inactive: noInactive })} onClick={() => this.setOutcome(false)}>No...</div>
          </div>
        </div>

        {outcomeNode}
        
      </div>
    );
  }

  renderSave() {
    return (
      <div className="save-escape">

        <div className="save-escape-blurb">
          <p>Sign up to <b>save your escape</b>. You can also write a review of <b>{this.state.room.name}</b> and track all your other escapes.</p>
          {/*<p>The room owner will be notified when you save your escape, and they'll be able to <b>verify your escape</b> and time.</p>*/}
        </div>

        <RegisterForm
          doRegister
          values={{}}
          errors={this.props.errors.register}
          buttonText="Track Your Escape"
          onSuccess={(resp) => this.handleRegisterSuccess(resp)}
        />
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="TrackLocation">
        {this.state.flow == 'rooms' && this.renderRooms()}
        {['escape', 'save'].includes(this.state.flow) && this.renderEscapeForm()}
        {this.state.flow == 'save' && this.renderSave()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    location: state.get.location,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    login,
    register,
    fetchUser,
    getRankEscape,
    addEscape,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrackLocation);



/** WEBPACK FOOTER **
 ** ./src/components/TrackLocation.js
 **/